import { useState, useCallback } from 'react';
import { apiClient } from 'core/utils/apiClient';

export type Hospital = {
  /** 病院ID */
  id: string;
  /** 病院名 */
  name: string;
};

export const useUsingDashboardHospitals = () => {
  const [hospitals, setHospitals] = useState<Hospital[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchHospitals = useCallback(async (emsTeamId: string) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await apiClient.get<Hospital[]>(
        `/ems-teams/${emsTeamId}/using-dashboard-hospitals`
      );

      setHospitals(response.data || []);
    } catch (err) {
      console.error('ダッシュボード使用病院リストの取得に失敗しました:', err);
      setHospitals([]);
      
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError('病院リストの取得に失敗しました');
      }
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    hospitals,
    isLoading,
    error,
    fetchHospitals
  };
}; 